<style scoped lang="less">
</style>

<template>
    <div class="yb-container">
        <div class="line-container">
            <el-input placeholder="姓名、电话" size="mini" style="width: 200px;" clearable @keyup.native.enter="refetchData" prefix-icon="el-icon-search" v-model="keyword"></el-input>
            <el-button class="margin-l" size="mini" type="primary" @click.stop="refetchData" :loading="loading">搜索</el-button>
        </div>

        <paged-table :page-size="100" class="block-mini-top" ref="table" @fetch-data="fetchData">
            <el-table slot :data="data" border size="mini" :cell-style="$parent.$parent.cellStyle">
                <el-table-column type="index" align="center" width="45">
                </el-table-column>
                <el-table-column label="时间" align="center" width="150">
                    <template slot-scope="scope">
                        {{scope.row.createdAt | fmt-time}}
                    </template>
                </el-table-column>
                <el-table-column label="姓名" align="center" width="120">
                    <template slot-scope="scope">
                        {{scope.row.user.name}}
                    </template>
                </el-table-column>
                <el-table-column label="电话" align="center" width="120">
                    <template slot-scope="scope">
                        {{scope.row.user.phone}}
                    </template>
                </el-table-column>
                <el-table-column label="页面" align="center" width="100">
                    <template slot-scope="scope">
                        <div :style="pageStyle(scope.row.page)">{{scope.row.page | fmt-track-page}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="备注">
                    <template slot-scope="scope">
                        <div v-if="scope.row.remarks">{{scope.row.remarks}}</div>
                        <div v-if="scope.row.page == 'goodDetail' && scope.row.good">{{scope.row.good}}</div>
                        <div v-else-if="scope.row.page == 'newsDetail' && scope.row.news">{{scope.row.news}}</div>
                        <div v-else-if="scope.row.page == 'orderDetail' && scope.row.order">{{scope.row.order}}</div>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="操作" width="120">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" class="super-mini-button" @click.stop="addOrEdit(scope.row)">编辑</el-button>
                        <el-button type="danger" size="mini" class="super-mini-button" @click.stop="removeModel(scope.row)">删除</el-button>
                    </template>
                </el-table-column> -->
            </el-table>
        </paged-table>
        <dialog-edit-news ref="edit" @fetch-data="fetchData"></dialog-edit-news>
    </div>
</template>

<script>
import PagedTable from "../components/PagedTable.vue";
import { HttpClient } from "../util/http";
import { actionConfirm, msgError, msgSuccess } from "../util/toast";
import { removeModel } from "../util/restful";
import DialogEditNews from "../components/dialog/dialogEditNews.vue";

export default {
    components: {
        PagedTable,
        DialogEditNews,
    },
    mixins: [],
    data() {
        return {
            data: [],
            keyword: "",
            loading: false,
            totalList: [],
        };
    },
    created() {},
    mounted() {},
    computed: {
        table() {
            return this.$refs.table;
        },
        edit() {
            return this.$refs.edit;
        },
    },
    mounted() {},
    methods: {
        pageStyle(page) {
            let style = "";
            if (page == "login") {
                style = "color:#67c23a; font-weight:bold; font-size:14px";
            }
            return style;
        },
        refetchData() {
            this.table.refetchData();
        },
        async fetchData() {
            let cond = {
                pageSize: this.table.pageSize,
                pageNum: this.table.pageNum,
            };
            if (this.keyword) {
                cond["keyword"] = this.keyword;
            }
            this.loading = true;
            let res = await HttpClient.post("/track/get/admin", cond);
            this.data = res.result;
            this.table.submitTotal(res.count);
            this.loading = false;
        },
        addOrEdit(item) {
            this.edit.addOrEdit(item);
        },
    },
};
</script>
